import api from "../api"

export const ACTION_TYPES = {
    CLEAN_USER_PROFILE: 'CLEAN_USER_PROFILE',
    FETCH_DASHBOARD: 'FETCH_DASHBOARD',
    FETCH_OC_BY_STATUS: 'FETCH_OC_BY_STATUS',
    FETCH_EVIDENCE: 'FETCH_EVIDENCE',
    FETCH_ORDER_DETAIL_MAINTENANCE: 'FETCH_ORDER_DETAIL_MAINTENANCE',
    FETCH_INVOICE_HISTORY: 'FECTH_INVOICE_HISTORY',
    RESULT_UPLOAD_INVOICE: 'RESULT_UPLOAD_INVOICE',
    RESULT_UPLOAD_MARKUP_INVOICE: 'RESULT_UPLOAD_MARKUP_INVOICE',
    RESULT_UPLOAD_COMPLEMENT: 'RESULT_UPLOAD_COMPLEMENT',
    FETCH_INVOICE_COMPLEMENT: 'FETCH_INVOICES_COMPLEMENT',
    FETCH_REJECTED_INVOICE: 'FETCH_REJECTED_INVOICE'
}

export const fetch_Dashboard = (lang, token, supplierId, onError, onSuccess) => dispatch => {
    api.Maintenance().fetchDashboard(lang, token, supplierId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_DASHBOARD,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fecth_oc_by_status = (lang, token, supplierId, status, startDate, endDate, filter, onError, onSuccess) => dispatch => {
    api.Maintenance().fetchOCByStatus(lang, token, status, startDate, endDate, filter, supplierId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_OC_BY_STATUS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fecth_Evidence = (lang, token, orderId, option, onError, onSuccess) => dispatch => {
    api.Maintenance().fetchEvidence(lang, token, orderId, option)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_EVIDENCE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const Update_Evidence = (lang, token, orderId, file, option, onError, onSuccess) => dispatch => {
    api.Maintenance().uploadEvidence(lang, token, orderId, file, option)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_EVIDENCE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_Evidence = (lang, token, evidenceId, orderId, option, onError, onSuccessDelete) => dispatch => {
    api.Maintenance().DeleteEvidence(lang, token, evidenceId, orderId, option)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_EVIDENCE,
                payload: response.data
            })
            onSuccessDelete()
        })
        .catch(err => onError(err))
}

export const Update_Invoice = (lang, token, orderId, files, onError, onSuccess) => dispatch => {
    api.Maintenance().uploadInvoice(lang, token, orderId, files)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.RESULT_UPLOAD_INVOICE,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const Update_Markup_Invoice = (lang, token, orderId, files, onError, onSuccess) => dispatch => {
    api.Maintenance().uploadMarkupInvoice(lang, token, orderId, files)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.RESULT_UPLOAD_MARKUP_INVOICE,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Invoice_History = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Maintenance().fetchInvoiceHistory(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_INVOICE_HISTORY,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Order_Detail = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Maintenance().fetchOrderDetail(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ORDER_DETAIL_MAINTENANCE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const Update_Complement = (lang, token, orderId, file, onError, onSuccess) => dispatch => {
    api.Maintenance().UploadComplement(lang, token, orderId, file)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.RESULT_UPLOAD_COMPLEMENT,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Invoice_Complement = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Maintenance().fetchInvoiceComplement(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_INVOICE_COMPLEMENT,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Rejected_Invoice = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Maintenance().fetchRejectedInvoice(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_REJECTED_INVOICE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_Rejected_Invoice = (lang, token, invoiceId, onSuccessDelete, onError) => dispatch => {
    api.Maintenance().DeleteRejectedInvoice(lang, token, invoiceId)
        .then(response => {
            onSuccessDelete()
        })
        .catch(err => onError(err))
}